/**
 * Created by andrey on 08.08.2025
 */

cc.easeIn = function (rate) {
    return (dt) => Math.pow(dt, rate);
};

cc.easeOut = function (rate) {
    return (dt) => Math.pow(dt, 1 / rate);
};

cc.easeInOut = function (rate) {
    return (dt) => {
        dt *= 2;
        if (dt < 1) {
            return 0.5 * Math.pow(dt, rate);
        }
        return 1.0 - 0.5 * Math.pow(2 - dt, rate);
    };
};

cc.easeExponentialIn = function () {
    return (dt) => (dt === 0 ? 0 : Math.pow(2, 10 * (dt - 1)));
};

cc.easeExponentialOut = function () {
    return (dt) => (dt === 1 ? 1 : (-(Math.pow(2, -10 * dt)) + 1));
};

cc.easeExponentialInOut = function () {
    return (dt) => {
        if (dt !== 1 && dt !== 0) {
            dt *= 2;
            if (dt < 1) {
                return 0.5 * Math.pow(2, 10 * (dt - 1));
            }
            return 0.5 * (-Math.pow(2, -10 * (dt - 1)) + 2);
        }
        return dt;
    };
};

cc.easeBackIn = function (rate = 1.70158) {
    return (time1) => {
        const overshoot = rate;
        return (time1 === 0 || time1 === 1) ? time1 : time1 * time1 * ((overshoot + 1) * time1 - overshoot);
    };
};

cc.easeBackOut = function (rate = 1.70158) {
    return (time1) => {
        const overshoot = rate;
        time1 -= 1;
        return time1 * time1 * ((overshoot + 1) * time1 + overshoot) + 1;
    };
};

cc.easeBackInOut = function () {
    return (time1) => {
        const overshoot = 1.70158 * 1.525;
        time1 *= 2;
        if (time1 < 1) {
            return (time1 * time1 * ((overshoot + 1) * time1 - overshoot)) / 2;
        }
        time1 -= 2;
        return (time1 * time1 * ((overshoot + 1) * time1 + overshoot)) / 2 + 1;
    };
};

cc.easeQuadraticActionIn = function () {
    return (time) => Math.pow(time, 2);
};

cc.easeQuadraticActionOut = function () {
    return (time) => -time * (time - 2);
};

cc.easeQuadraticActionInOut = function () {
    return (time) => {
        let resultTime = time;
        time *= 2;
        if (time < 1) {
            resultTime = time * time * 0.5;
        } else {
            --time;
            resultTime = -0.5 * (time * (time - 2) - 1);
        }
        return resultTime;
    };
};

cc.easeQuarticActionIn = function () {
    return (time) => time * time * time * time;
};

cc.easeQuarticActionOut = function () {
    return (time) => {
        time -= 1;
        return -(time * time * time * time - 1);
    };
};

cc.easeQuarticActionInOut = function () {
    return (time) => {
        time *= 2;
        if (time < 1) {
            return 0.5 * time * time * time * time;
        }
        time -= 2;
        return -0.5 * (time * time * time * time - 2);
    };
};

cc.easeCubicActionInOut = function () {
    return (time) => {
        time *= 2;
        if (time < 1) {
            return 0.5 * time * time * time;
        }
        time -= 2;
        return 0.5 * (time * time * time + 2);
    };
};

cc.easeCubicActionOut = function () {
    return (time) => {
        time -= 1;
        return (time * time * time + 1);
    };
};

cc.easeCubicActionIn = function () {
    return (time) => time * time * time;
};

cc.easeOutIn = function (rate) {
    return (dt) => {
        dt *= 2;
        if (dt < 1) {
            return 0.5 - 0.5 * Math.pow(1 - dt, rate);
        }
        return 0.5 + 0.5 * Math.pow(dt - 1, rate);
    };
};

cc.easeElasticIn = function (period = 0.3) {
    return (dt) => {
        if (dt === 0 || dt === 1) {
            return dt;
        }
        dt -= 1;
        return -Math.pow(2, 10 * dt) * Math.sin((dt - (period / 4)) * Math.PI * 2 / period);
    };
};

cc.easeElasticOut = function (period = 0.3) {
    return (dt) => ((dt === 0 || dt === 1) ? dt : Math.pow(2, -10 * dt) * Math.sin((dt - (period / 4)) * Math.PI * 2 / period) + 1);
};

cc.easeElasticInOut = function (period = 0.3) {
    return (dt) => {
        let newT = 0;
        if (dt === 0 || dt === 1) {
            newT = dt;
        } else {
            dt *= 2;
            const s = period / 4;
            dt -= 1;
            if (dt < 0) {
                newT = -0.5 * Math.pow(2, 10 * dt) * Math.sin((dt - s) * Math.PI * 2 / period);
            } else {
                newT = Math.pow(2, -10 * dt) * Math.sin((dt - s) * Math.PI * 2 / period) * 0.5 + 1;
            }
        }
        return newT;
    };
};

cc.easeSineInOut = function () {
    return (dt) => ((dt === 0 || dt === 1) ? dt : -0.5 * (Math.cos(Math.PI * dt) - 1));
};

cc._bounceTime = (time1) => {
    if (time1 < 1 / 2.75) {
        return 7.5625 * time1 * time1;
    } if (time1 < 2 / 2.75) {
        time1 -= 1.5 / 2.75;
        return 7.5625 * time1 * time1 + 0.75;
    } if (time1 < 2.5 / 2.75) {
        time1 -= 2.25 / 2.75;
        return 7.5625 * time1 * time1 + 0.9375;
    }

    time1 -= 2.625 / 2.75;
    return 7.5625 * time1 * time1 + 0.984375;
};

cc.easeBounceIn = function () {
    return (dt) => 1 - cc._bounceTime(1 - dt);
};

cc.easeBounceOut = function () {
    return (dt) => cc._bounceTime(dt);
};

cc.easeBounceInOut = function () {
    return (time1) => {
        let newT;
        if (time1 < 0.5) {
            time1 *= 2;
            newT = (1 - cc._bounceTime(1 - time1)) * 0.5;
        } else {
            newT = cc._bounceTime(time1 * 2 - 1) * 0.5 + 0.5;
        }
        return newT;
    };
};

cc.easeSineOut = function () {
    return (dt) => ((dt === 0 || dt === 1) ? dt : Math.sin(dt * Math.PI / 2));
};

cc.easeSineIn = function () {
    return (dt) => ((dt === 0 || dt === 1) ? dt : -1 * Math.cos(dt * Math.PI / 2) + 1);
};